import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\"><defs><style></style></defs><path d=\"M829.18 425.248C889.662 461.3 963.872 558.56 994.75 675.643c30.876 117.078 25.757 221.921 25.757 221.921s-39.973-64.564-56.18-87.196-84.503-106.956-190.51-155.832c-106.007-48.873-283.2-40.169-283.2-40.169v203.516L2.277 471.973l488.34-345.907v205.388s117.311 8.829 178.63 21.528c103.283 21.388 159.934 72.266 159.934 72.266z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol